import { TrendingUp, Warning, TrendingDown, Error } from '@mui/icons-material';

export const PHASE_COLORS = {
  UP_NEUTRAL: {
    color: '#16a34a',
    bg: '#dcfce7',
    labelKey: 'downtrend.phases.UP_NEUTRAL',
    icon: <TrendingUp />,
    severity: 0,
  },
  EARLY_WARNING: {
    color: '#ea580c',
    bg: '#ffedd5',
    labelKey: 'downtrend.phases.EARLY_WARNING',
    icon: <Warning />,
    severity: 1,
  },
  CONFIRMED_DOWN: {
    color: '#e11d48',
    bg: '#ffe4e6',
    labelKey: 'downtrend.phases.CONFIRMED_DOWN',
    icon: <TrendingDown />,
    severity: 2,
  },
  SEVERE_DOWN: {
    color: '#be123c',
    bg: '#fce7f3',
    labelKey: 'downtrend.phases.SEVERE_DOWN',
    icon: <Error />,
    severity: 3,
  },
};

export const getPhaseColor = (phase) => {
  return PHASE_COLORS[phase] || PHASE_COLORS.UP_NEUTRAL;
};

export const getRiskColor = (score) => {
  if (score === null || score === undefined) return '#64748b';
  if (score < 30) return '#16a34a';
  if (score < 50) return '#84cc16';
  if (score < 70) return '#f59e0b';
  return '#e11d48';
};

export const getRiskLabel = (score, t) => {
  if (score === null || score === undefined) return t('downtrend.riskLabels.na');
  if (score < 30) return t('downtrend.riskLabels.low');
  if (score < 50) return t('downtrend.riskLabels.moderate');
  if (score < 70) return t('downtrend.riskLabels.high');
  return t('downtrend.riskLabels.critical');
};

